import React from 'react';
import { Card, Button } from 'antd';
import BaseComponent from 'base/BaseComponent';
import { enhance } from 'base/BaseEnhance';
import './Main.less';
import { isEqual } from 'lodash';

/**
 * 主页面
 */
class Main extends BaseComponent {
  constructor(props) {
    super();
    this.state = {
      adShowFlag: false,
      mainShowFlag: true
    };
  }

  componentDidMount() {
    this.getSysProfileSettingValue();
  }

  componentWillUnmount() { }

  jumpToCreditModifyView = () => {
    super.addTabByPath('金融授信申请', '/supCredit/SupCreditApply', 'supCreditApply');
  }

  getSysProfileSettingValue = () => {
    super.sendPostRequest('/plat-delivery/profile/getProfileByCode', { code: 'HMM_CREDIT_INTRODUCTION_SHOW_FLAG' }, (result) => {
      if (result != null && isEqual(result, 'YES')) {
        this.setState({
          adShowFlag: true,
          mainShowFlag: true
        });
      }
    });
  }

  jumpToFlow = () => {
    this.setState({
      mainShowFlag: false
    });
  }

  backToMain = () => {
    this.setState({
      mainShowFlag: true
    });
  }

  mainContent = () => {
    return (
      <Card title="百汇峰禾供应链金融"
        headStyle={{ fontSize: 25, color: '#133C6A', fontWeight: 700 }}
        className="main-page"
        extra={<Button type="primary"
          onClick={this.jumpToFlow}>申请流程</Button>}>
        <img src="/assets/imgs/finanaceIndex.png" style={{ width: '100%', height: 'auto' }} alt="金融首页"/>
      </Card>);
  }

  flowContent = () => {
    return (
      <Card title="百汇峰禾供应链金融"
        headStyle={{ fontSize: 25, color: '#133C6A', fontWeight: 700 }}
        className="main-page"
        extra={<><Button onClick={this.backToMain} style={{ marginRight: 30 }}>返回</Button><Button type="primary" onClick={this.jumpToCreditModifyView}>获取资金</Button></>}>
        <img src="/assets/imgs/finanaceFlow.png" style={{ width: '100%', height: 'auto' }} alt="金融流程"/>
      </Card>);
  }

  render() {
    const { adShowFlag, mainShowFlag } = this.state;
    return (
      adShowFlag
        ? (mainShowFlag ? this.mainContent() : this.flowContent())
        : (<div className="main-page">Main</div>)
    );
  }
}
export default enhance(Main);
